// extracted by mini-css-extract-plugin
export default {"alertsWrapper":"AlertPopup_alertsWrapper__1053a","popupTitle":"AlertPopup_popupTitle__w6iZ-"};